import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=593e312d&scoped=true&"
import script from "./modelInfo.vue?vue&type=script&lang=js&"
export * from "./modelInfo.vue?vue&type=script&lang=js&"
import style0 from "./modelInfo.vue?vue&type=style&index=0&id=593e312d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593e312d",
  null
  
)

export default component.exports